export default __webpack_public_path__ + "064332e7ac2d4e0a34975c49aa8586de.png";